import { useRef } from 'react'

export function useLatest<T = unknown>(value: T) {
  const ref = useRef(value)
  ref.current = value

  return ref
}
